import {
  useCallback 
} from "react"

import {
  DELIMITER 
} from "@/hooks/FilterModal/helpers"
import {
  useSearchParams 
} from "next/navigation"

// TODO: derive from store config when available
const setSearchParams = (existing, options) => {
  const params = new URLSearchParams(existing)
  const {
    categoryId, label, searchValue 
  } = options

  params.set("query", searchValue)
  params.set("category_id_filter", `${label}${DELIMITER}${categoryId}`)

  return `${params}`
}

export const useSuggestedCategory = (props) => {
  const {
    onNavigate, ...restProps 
  } = props
  const searchParams = useSearchParams()

  const nextSearchParams = setSearchParams(searchParams, restProps)
  const destination = `/search.html?${nextSearchParams}`

  const handleClick = useCallback(() => {
    if (typeof onNavigate === "function") {
      onNavigate()
    }
  }, [onNavigate])

  return {
    destination,
    handleClick,
  }
}
